import { instance } from "libs/api";

import { Category, CategoryPriorityPayload } from "../../categories.types";
import { ApiRoutesCategories } from "./../../constants";

export const requestCategoryPriority = async (
  body: CategoryPriorityPayload
): Promise<Category[]> => {
  return await instance.put(ApiRoutesCategories.CategoryPriority, body);
};
